import { FC } from 'react';
import { TCircleSvgProps } from './types';

export const CircleSvg: FC<TCircleSvgProps> = ({ num, active = false }) => (
	<svg
		focusable="false"
		aria-hidden="true"
		viewBox="0 0 24 24"
		style={{
			userSelect: 'none',
			width: '1em',
			height: '1em',
			fill: 'currentColor',
			flexShrink: '0',
			fontSize: '1.5rem',
			display: 'block',
			color: active ? '#016197' : 'rgba(0, 0, 0, 0.38)',
		}}
	>
		<circle cx="12" cy="12" r="12" />
		<text
			x="12"
			y="12"
			textAnchor="middle"
			dominantBaseline="central"
			style={{
				color: 'white',
				fontSize: '0.75rem',
			}}
		>
			{num}
		</text>
	</svg>
);
